<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="d-flex justify-content-between">
        <div class="section-title">
          {{ "Concesion Item Wise Transfer Report" }}
        </div>       
        <div class="d-flex align-items-center">         
          <div class="d-flex align-item-center">
                <input value="1" type="radio" v-model="lang_id">
                <span class="ml-1">English</span>
              </div>
              <div class="d-flex align-item-center ml-2">
              <input value="2" type="radio" v-model="lang_id">

              <span class="ml-1">العربية</span>
            </div>
        </div>
      </div>
      <!-- <div>
          <small><em>{{ $t("* As Per Business Date") }}</em></small>
        </div> -->
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label :class="dropDown.selectedCinema ? 'shift-up' : 'font-weight-bold'"
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                             :disabled="isRoleID"
                             :options="dropDown.cinemas"
                             v-model="dropDown.selectedCinema"
                             :searchable="true"
                             label="cine_name"
                             track-by="cine_id"
                             placeholder="Movie"
                             @input="onSelectCinema($event)"
                             :allowEmpty="false"
                             :showLabels="false"
                           ></multiselect>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                              ✖
                            </button> -->
                            <Datepicker
                :monday-first="true"
                type="date"
                ref="programaticOpen"
                v-model="fromDate"
                v-validate="'required'"
                @selected="onChangeDate($event, 'from')"
              ></Datepicker>
              <label :class="fromDate ? 'active' : ''">
                <!-- {{ $t("show") }} -->
                {{ $t("fromdate") }}
              </label>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                >
                </Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label
                >
              </div>
            </div>    
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="dropdown-curve-container">
            <label :class="selectedItemName && selectedItemName.length > 0 ? 'shift-up' : 'font-weight-bold'">
              
            </label>
            <multiselect v-model="selectedItemName" :options="allItemNames" track-by="rm_id"
              label="rm_name" :disabled="isRoleID" :searchable="true" placeholder="Material" :multiple="false">
            </multiselect>
          </div>
        </div>

          <div class="col-12 col-md-6 col-lg-6 col-xl-1 align-self-center mb-3">
            <button class="btn-blue-lg w-100" @click="onSubmit">
              {{ $t("fetch") }}
             
            </button>
          </div>
          <div
            v-if="concessionData.length > 0"
            class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- s -->

            <a
              target="_blank"
              @click="getConcessionData('Y', 'N')"
              title="Download as Excel"
              download
              style="cursor: pointer;"
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
            <a
              target="_blank"
              @click="getConcessionData('N', 'Y')"
              title="Download as PDF"
              download
              style="cursor: pointer;"
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/pdf.svg"
                height="25"
                width="25"
              />
            </a>
          </div>
        </div>
      </div>

      <div class="swc-report">
          <table
class="swc-report-table"
:class="lang_id == 2 ? 'swc-report-table reverse-order' : 'swc-report-table order'"
border="1"
>
<thead class="bg-lightgrey">
  <tr :class="lang_id == 2 ? 'text-right' : 'text-center'">
    <th>{{ trans("Cost_balance", lang_id) }}</th>
    <th>{{ trans("Total_Cost", lang_id) }}</th>
     <th>{{ trans("Item_Cost", lang_id) }}</th>
    <th>{{ trans("Item_Request_Form_no", lang_id) }}</th>
     <th>{{ trans("Reason", lang_id) }}</th>
    <th>{{ trans("Stock", lang_id) }}</th>
     <th>{{ trans("Spend", lang_id) }}</th>
    <th>{{ trans("Import", lang_id) }}</th>
     <th>{{ trans("Purchase_Return", lang_id) }}</th>
    <th>{{ trans("Transfer_In", lang_id) }}</th>
     <th>{{ trans("Property_In", lang_id) }}</th>
    <th>{{ trans("Property_Out", lang_id) }}</th>
     <th>{{ trans("Standard_Consumed", lang_id) }}</th>
    <th>{{ trans("Wastage", lang_id) }}</th>
     <th>{{ trans("Variance", lang_id) }}</th>
    <th>{{ trans("System_Stock", lang_id) }}</th>
     <th>{{ trans("Date", lang_id) }}</th>
    <th>{{ trans("SubWare_House", lang_id) }}</th>
     <th>{{ trans("Main_Ware_House", lang_id) }}</th>

  </tr>
</thead>

<tbody v-if="concessionData.length">
  <tr  v-for="(data, index) in concessionData"
  :key="index"> 
    <td class="text-left">{{ currFormat3(data.purchase_rate * (data.system_stock || 0)) }}</td>
    <td class="text-left">{{ currFormat3(data.purchase_rate * (data.transfer_out || data.system_stock || 0)) }}</td>
    <td class="text-right">{{  currFormat(data.purchase_rate) }}</td>
    <td class="text-right">{{data.transfer_id}}</td>
    <td>
         {{ 
    data.transfer_out && data.purchase_stock ? 'Transfer, Add to Stock' :
    data.transfer_out ? 'Transfer' :
    data.purchase_stock ? 'Add to Stock' : '-'
  }}
    </td>
    
    <td class="text-right">{{  currFormat3(data.opening_stock)  }}</td>
    <td class="text-right">{{ currFormat3(data.transfer_out) || "00" }}</td>
    <td class="text-right">{{ currFormat3(data.purchase_stock) || "00" }}</td>

    <td class="text-right"> {{ currFormat3(data.purchase_return) }} </td>
    <td class="text-right"> {{ currFormat3(data.transfer_in) }} </td>
    <td class="text-right"> {{ currFormat3(data.property_in) }} </td>
    <td class="text-right"> {{ currFormat3(data.property_out) }} </td>
    <td class="text-right"> {{ currFormat3(data.standard_consumed) }} </td>
    <td class="text-right"> {{ currFormat3(data.wastage) }} </td>
    <td class="text-right"> {{ currFormat3(data.variance) }} </td>
    <td class="text-right"> {{ currFormat3(data.system_stock) }} </td>

    <td class="text-left">{{moment(data.cogs_date).format("YYYY-MM-DD") }}</td>
   <td class="text-right" >
  {{ data.transfer_to }}
</td>
    <td class="text-right" :style="{ backgroundColor: data.v_name ? 'lightgreen' : '' }">{{ data.v_name || data.sm_store_name}}</td>
  </tr>
</tbody>

<tbody v-else>
  <tr>
    <td colspan="18" class="text-center">No Record</td>
  </tr>
</tbody>
</table>

      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/NewReportService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import NewReportService from "../../../services/NewReportService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
 import ReportService from "@/services/ReportsService";
 import { authenticationService } from "@/services/AuthenticationService";
import * as XLSX from "xlsx";
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
    VueTimepicker
  },
  data() {
    return {
        selectedDistributor:[],
       selectedUsers:[],
       Users:[],
      end_time: "",
      start_time: "",
      BASEURL,
      isRoleID: false,
      submitted: false,
      lang_id:"1",
     
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
        selectedCineAddress: ""
      },
      selectedCinema:[],
      concessionData: [],
      selectedScreen:[],

      fromDate: null,
      toDate: null,
      grandTotal: {},
      selectedItemName: [],
      allItemNames: [],
      selectedScreenName:[],
      allScreenNames:[],
       selectedPaymentSource:[],
       paymentList:[],
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();

  },
  watch: {
    fromDate() {
    this.getConcessionData("N", "N", "filter");
  },
  toDate() {
    this.getConcessionData("N", "N", "filter");
  },
  },
  mounted() {},
  computed: {

    currentSelectedLanguage() {
      return this.$store.getters.GET_SELECTED_HEADER_LANGUAGE;
    },
  },
  methods: {
    moment,
    onChangeDate(e, type){
    if(type == 'from'){
      this.toDate = new Date(e);
      this.$forceUpdate();
    }
  },
      getCinemaList: function () {
          MasterService.GetCinemas()
            .then((response) => {
              const { data } = response;
              if (data.status && data.Records.length > 0) {
                this.dropDown.cinemas = data.Records;
                this.CinemasCopy = data.Records;
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        },
  onSelectCinema: function (event) {
       this.dropDown.selectedCinema = event;
       this.dropDown.selectedCinemaName = event.cine_name;
       this.dropDown.selectedCinemaId = event.cine_id;
       this.dropDown.selectedCinemaAddres = event.cine_address;
       this.$store.dispatch("selectDropdownCinema", event);
     },
    onSubmit() {
       if (!this.selectedItemName || !this.selectedItemName.rm_id) {
    return this.$toasted.show("Please Select Item");
  }
      this.getConcessionData("N","N");
    },

  async getConcessionData( isExcel = "N", isPdf = "N", type = "") {
 if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
if (!this.fromDate) {
  return this.$toasted.show("Select From Date");
}
//  if (!this.selectedItemName.rm_id) {
//         return this.$toasted.show("Please Select Item");
//       }

let loader;
try {
  let cinemaIds = [];
  let cinemaName = "";
  let cinemaAddress = "";

  if (this.selectedCinema.length) {
    if (this.selectedCinema[0].cine_id === 0) {
      cinemaIds = this.CinemasCopy.map(cinema => cinema.cine_id);
      cinemaName = "All Cinemas";
      cinemaAddress = ""; 
    } else {
      cinemaIds = this.selectedCinema.map(cinema => cinema.cine_id);
      cinemaName = this.selectedCinema.map(cinema => cinema.cine_name).join(", ");
      cinemaAddress = this.selectedCinema.map(cinema => cinema.cine_address).join(", ");
    }
  }

  this.concessionData = [];
  loader = this.$loading.show();
  let payload = {
     cinema_id: this.dropDown.selectedCinemaId,
    cinema_name: this.dropDown.selectedCinemaName,
    cinema_address: this.dropDown.selectedCinemaAddres,
    fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
    toDate: moment(this.toDate).format("YYYY-MM-DD"),
    lang_id: this.lang_id,
    isPdf,
    isExcel,
    rm_id: this.selectedItemName.rm_id
  };
  console.log("payload",payload)
  if (type === "filter") {
    payload["type"] = "filter";
  }

    if (this.selectedItemName.length) {
      payload["selectedItemName"] = this.selectedItemName.map(
        (item) => {
          return {
      rm_id: item.rm_id,
      rm_name: item.rm_name
    };
        }
      );
    }
  let response = await NewReportService.getCurrentStockReportNew(payload);
  const { data } = response;
  if (!data.status) return this.$toasted.show(data.message);
    if (type == "filter") {
          this.allItemNames = [...data.materialNamesData];
        } 
        else {
    this.concessionData = data.Records;
    if (isPdf == "Y" && data.pdfPath) {
      window.open(data.pdfPath, "_blank");
    }
    if (isExcel == "Y" && data.excelPath) {
      window.open(data.excelPath, "_blank");
    }
    this.$toasted.show(data.message);
  } 
  loader.hide();

} catch (error) {
  console.log(error);
} finally {
  if (loader) {
    loader.hide();
  }
}
},
  }
};
</script>


<style scoped>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}

.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  border: 1px solid black;
}

.swc-report-table th {
  border: 1px solid black !important;
}

.swc_table_header th {
  border: 1px solid black !important;
}

.rtl-table-scroll {
  direction: rtl;
}

.color-blue {
  background-color: #cccccc;
}
.text-bold {
  font-weight: bold;
}
.rtl-table {
  display: flex;
  flex-direction: row-reverse; /* Reverse column order */
}

.rtl-table td {
  text-align: right; /* Align text properly for Arabic */
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  background-color: blue !important;
  border-color: blue !important;
}
.reverse-order{
  direction: rtl;
}
.order{
  direction: ltr
}

/* Change radio button color */
.j-radio .custom-control-input:checked ~ .custom-control-label::before {
  background-color: red !important; /* Change the radio background color */
  border-color: red !important; /* Change the border color */
}
</style>


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/fnbCategoryReportAsPerStoreTransfer.vue